<template>
  <div>
    <custom-dialog width="800px" :showClose="false" :close-on-press-escape="false" title="查询医保信息"
      v-if="visibleObj.yibaoDialog" :visible="visibleObj.yibaoDialog" @close="dialogVisible('yibaoDialog')">
      <div class="yb-warp" slot="content" v-loading="loading" :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading">
        <div>
          <el-steps :active="yibaoStept" align-center>
            <el-step title="查询患者信息"></el-step>
            <el-step title="医保上传数据"></el-step>
            <el-step title="结算完成"></el-step>
          </el-steps>
        </div>
        <div v-if="yibaoStept == 3" class="success-warp">
          <div class="success-title">结算成功！</div>
          <div class="info-warp">
            <div class="detail-item">
              <div>医疗费用总额：</div>
              <div> {{ yibaoObj.price }} </div>
            </div>
            <div class="detail-item">
              <div>医保支付合计：</div>
              <div>{{ computedYBPayTotal }}</div>
            </div>
            <div class="detail-item col-5A6678">
              <div>医保基金支付：</div>
              <div>{{ setlinfo.fund_pay_sumamt }}</div>
            </div>
            <div class="detail-item col-5A6678">
              <div>个人账户支付：</div>
              <div>{{ setlinfo.acct_pay }}</div>
            </div>
            <div class="detail-item col-5A6678">
              <div>医保钱包支付：</div>
              <div>{{ setlinfo.exp_content_obj && setlinfo.exp_content_obj.wltpay_amt ? setlinfo.exp_content_obj.wltpay_amt : 0 }}</div>
            </div>
            <div class="detail-item col-5A6678" v-if="gjSetlinfo && gjSetlinfo.acct_pay">
              <div>亲属共济支付：</div>
              <div>{{ gjSetlinfo.acct_pay }}</div>
            </div>
            <div class="detail-item">
              <div>个人账户余额：</div>
              <div>{{ setlinfo.balc }}</div>
            </div>
            <div class="detail-item" v-if="gjSetlinfo && gjSetlinfo.balc">
              <div>亲属个人账户余额：</div>
              <div>{{ gjSetlinfo.balc }}</div>
            </div>
            <div class="detail-item">
              <div>个人现金支付：</div>
              <div>{{ gjSetlinfo && gjSetlinfo.acct_pay ? gjSetlinfo.psn_cash_pay : setlinfo.psn_cash_pay }}</div>
            </div>
          </div>
          <el-button class="close-btn" @click="cancel">关闭</el-button>
        </div>
        <div v-if="yibaoStept != 3">
          <div class="b1 p10 yibaoDialogRef" v-if="yibaoObj.baseinfo">
            <!-- <div class="b1 p10 yibaoDialogRef"> -->
            <!-- 隐藏输入框，用于聚焦，解决多次刷医保问题 -->
            <el-input ref="yibaoDialogRef-input" class="yibaoDialogRef-input"></el-input>
            <div class="display-f flex-f lh24"
              style="align-items: center; padding-bottom:8px; border-bottom: 1px solid #e6e6e6;">
              <div style="margin-right: 20px;">持卡人：{{ yibaoObj.baseinfo.psn_name }}</div>
            </div>
            <el-row>
              <el-col :span="6" class="lh24">
                <div>险种：{{ yibaoObj.insuinfoObj.label }}</div>
              </el-col>
              <el-col :span="6" class="lh24">
                <div>参保地：{{ yibaoObj.insuplc_admdvs_name || yibaoObj.insuinfoObj.insuplc_admdvs }}</div>
              </el-col>
              <el-col :span="6" class="lh24">
                <div>类别：{{ yibaoObj.insuinfoObj.psn_typeStr }}</div>
              </el-col>
              <el-col :span="6" class="lh24">
                <div>公务员：{{ yibaoObj.insuinfoObj.cvlserv_flag == 0 ? '否' : '是' }}</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6" class="lh24">
                <div>余额：{{ yibaoObj.insuinfoObj.balc }} 元</div>
              </el-col>
              <el-col :span="6" class="lh24">
                <div class="overflow-ellipsis">单位：{{ yibaoObj.insuinfoObj.emp_name }}</div>
              </el-col>
              <el-col :span="6" class="lh24">
                <div>慢特病：{{ disease }}</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6" class="lh24">
                <div>医生：{{ doctorInfo.doctorName }} </div>
              </el-col>
              <el-col :span="6" class="lh24">
                <div>诊断：{{ diagnosis }}</div>
              </el-col>
            </el-row>
            <el-row v-if="cumObj">
              <el-col :span="6" class="lh24">
                <div>门诊起付金额累计：{{ cumObj.Q1100 }} </div>
              </el-col>
              <el-col :span="6" class="lh24">
                <div>门诊统筹支付累计：{{ cumObj.Z999903 }}</div>
              </el-col>
            </el-row>
          </div>
          <div class="flex just-b mt20">
            <!-- <div class="mr10 fwb color1F2">医保支付方式</div> -->
            <el-radio-group v-model="is_wlt_acct" @input="ybPayWayChange">
              <el-radio :label="'0'">不使用医保钱包</el-radio>
              <el-radio :label="'1'">使用医保钱包</el-radio>
            </el-radio-group>
            <el-radio-group v-model="ybPayWay" @input="ybPayWayChange">
              <el-tooltip class="item" effect="light" content="超过7天用量部分将自动使用个账支付" placement="top-start">
                <el-radio :label="'1'">统筹</el-radio>
              </el-tooltip>
              <el-radio :label="'2'">个账</el-radio>
            </el-radio-group>
          </div>
          <custom-table ref="multipleTable" @selection-change="handleSelectionChange" border class="yibaoTable"
            :tableData="yibaoObj.items" :showPages="false" :column="column"></custom-table>
          <div class="dialog-footer">
            刷卡金额：{{ formatNumber(yibaoObj.price || 0) }}
            <el-button size="mini" :disabled="multipleSelection.length == 0" type="primary" @click="settlement"
              class="ml20">刷卡结算</el-button>
            <el-button size="mini" @click="cancel">取消</el-button>
          </div>

        </div>
      </div>
      <div slot="footer"></div>
    </custom-dialog>
    <custom-dialog title="费用确认" :showClose="false" :close-on-press-escape="false" width="343px" v-if="dialogShow"
      :visible.sync="dialogShow" :showFooter="false" :show-close="false">
      <div class="chrage-detail" slot="content" v-if="dialogShow" v-loading="settlementLoading"
        :element-loading-text="settlementLoadingText" element-loading-spinner="el-icon-loading">
        <div class="detail-item">
          <div>医疗费用总额：</div>
          <div> {{ setlinfo.medfee_sumamt }} </div>
        </div>
        <div class="detail-item">
          <div>医保支付合计：</div>
          <div>{{ computedYBPayTotal }}</div>
        </div>
        <div class="detail-item col-5A6678">
          <div>医保基金支付：</div>
          <div>{{ setlinfo.fund_pay_sumamt }}</div>
        </div>
        <div class="detail-item col-5A6678">
          <div>个人账户支付：</div>
          <div>{{ setlinfo.acct_pay }}</div>
        </div>
        <div class="detail-item col-5A6678">
          <div>医保钱包支付：</div>
          <div>{{ setlinfo.exp_content_obj && setlinfo.exp_content_obj.wltpay_amt ? setlinfo.exp_content_obj.wltpay_amt : 0 }}</div>
        </div>
        <div class="detail-item">
          <div>个人账户余额：</div>
          <div>{{ setlinfo.balc }}</div>
        </div>
        <div class="detail-item">
          <div>个人现金支付：</div>
          <div>{{ setlinfo.psn_cash_pay }}</div>
        </div>
        <div class="detail-btn">
          <el-button @click="cancelSettlement">取消</el-button>
          <el-button @click="submit" type="primary">确定</el-button>
        </div>
      </div>
      <div slot="footer"></div>
    </custom-dialog>
    <custom-dialog title="险种类型" :showClose="false" :close-on-press-escape="false" width="343px"
      v-if="insuranceDialogShow" :visible.sync="insuranceDialogShow" :showFooter="false" :show-close="false">
      <div class="insutype-warp" slot="content">
        <el-radio-group v-model="insutype">
          <el-radio v-for="item in insuinfoList" :key="item.insutype" :label="item.insutype">
            <div>{{ item.label }}</div>
            <div class="balc">余额：{{ item.balc }}</div>
          </el-radio>
        </el-radio-group>
        <div class="btn">
          <el-button type="primary" @click="next">下一步</el-button>
        </div>
      </div>
      <div slot="footer"></div>
    </custom-dialog>
    <custom-dialog title="共济账户支付" :showClose="false" :close-on-press-escape="false" width="343px" v-if="gjDialogShow"
      :visible.sync="gjDialogShow" :showFooter="false" :show-close="false">
      <div class="gj-warp" slot="content" v-loading="gjLoading" :element-loading-text="gjLoadingText"
        element-loading-spinner="el-icon-loading">
        <div class="gj-title">共济账户支付</div>
        <div class="gj-text">预计还需支付￥{{ setlinfo.psn_cash_pay }}，若可提供患者父母、配偶、子女的医保凭证，可继续使用共济账户刷卡支付。</div>
        <div class="btn">
          <el-button @click="gjPay" type="primary">共济支付</el-button>
          <el-button @click="gjDialogClose">取消</el-button>
        </div>
      </div>
      <div slot="footer"></div>
    </custom-dialog>
    <custom-dialog title="结果查询" :showClose="false" :close-on-press-escape="false" width="343px" v-if="resultDialogShow"
      :visible.sync="resultDialogShow" :showFooter="false" :show-close="false">
      <div class="result-warp" slot="content">
        <div class="result-title">正在查询医保结算结果，请稍候...</div>
        <div class="result-title mt10">100s</div>
      </div>
      <!-- <div class="result-warp" slot="content">
                <div class="result-title">超时未查询到医保结算结果</div>
                <div class="tips">提示：若您选择更换其他收款方式完成该订单，可能会出现重复收款的情况。您可在每日医保对账时，将医保部分退还至顾客</div>
                <div class="mt10">
                    <el-button type="primary">重新查询</el-button>
                    <el-button>更换其他收款方式</el-button>
                </div>
            </div> -->
      <div slot="footer"></div>
    </custom-dialog>
    <custom-dialog title="选择亲属关系" :showClose="false" :close-on-press-escape="false" width="343px"
      v-if="relationDialogShow" :visible.sync="relationDialogShow" :showFooter="false" :show-close="false">
      <div class="insutype-warp" slot="content">
        <el-radio-group v-model="gjRelation">
          <el-radio :label="item.value" v-for="item in relationOption" :key="item.value">{{ item.label }}</el-radio>
        </el-radio-group>
        <div class="btn">
          <el-button @click="gjDialogClose">取消</el-button>
          <el-button type="primary" @click="relationSelect">下一步</el-button>
        </div>
      </div>
      <div slot="footer"></div>
    </custom-dialog>
    <custom-dialog title="医保违规信息提示" :showClose="false" :close-on-press-escape="false" width="900px"
      v-if="beforeAnalyzeShow" :visible.sync="beforeAnalyzeShow" :showFooter="false" :show-close="false">
      <div class="insutype-warp" slot="content">
        <custom-table border class="yibaoTable" max-height="600" :tableData="beforeAnalyzeResult" :showPages="false"
          :column="beforeAnalyzeColumn"></custom-table>
        <div class="btn mt20">
          <el-button @click="beforeAnalyzeClose">取消</el-button>
          <el-button type="primary" v-if="!computedBeforeAnalyzeNext" @click="beforeAnalyzeConfirm">继续</el-button>
        </div>
      </div>
      <div slot="footer"></div>
    </custom-dialog>
  </div>
</template>

<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import CustomInput from '@/components/CustomInput'
import customTable from '@/components/customTable/customTable'
import { settlement, settlementCall, handleItems, personInfo, gjSettlement, preSettlement, feedback,initData } from '@/utils/yibaoTools'
import { Utils } from '@/utils/utils'
import { isNull, debounce, dictText, isEmptyArray } from '@/utils/validateBase'
import { CommonDTO, orderDTO } from '@/DTO/index'
import { ybPropertyList } from '@/utils/const'
import { queryOrder } from '@/api/pricingDetails'
const RULE_SEV_DEG = {
  1: '明确违规',
  2: '高度可疑',
  3: '轻度可疑',
}
export default {
  components: { CustomDialog, CustomInput, customTable },
  props: {
    visibleObj: {
      type: Object,
      default: () => { return {} }
    },
    dialogObj: {
      type: Object,
      default: () => { return {} }
    },
  },
  data() {
    return {
      loading: false,
      yibaoStept: 0,//医保步骤
      multipleSelection: [], // 医保刷卡药品已选表
      yibaoObj: {}, // 医保信息对象
      setlinfo: {},//医保费用详情对象
      gjSetlinfo: {},//医保费用详情对象
      dialogTitle: '费用确认',
      dialogShow: false,
      settlementLoading: false,//结算loading
      loadingText: '',//loading提示文字
      settlementLoadingText: '',//loading提示文字
      insuinfoList: [],//险种列表
      insuranceDialogShow: false,//险种类型弹框
      gjDialogShow: false,//共济支付弹框
      insutype: '',//险种类型
      column: [
        { type: 'selection' },
        { label: "扣费项目", prop: 'itemName' },
        { label: "医保编码", prop: 'med_list_codg' },
        {
          label: "医保属性", prop: 'medicalInsuranceType', formatter: (row) => {
            return dictText(row.medicalInsuranceType, ybPropertyList) || '仅个账'
          }, width: 80
        },
        { label: "单位", prop: 'unit', width: 60 },
        { label: "单价", prop: 'pric' },
        { label: "数量", prop: 'cnt' },
        { label: "小计", prop: 'det_item_fee_sumamt' },
      ],
      diagnosis: '',//诊断
      doctorInfo: {},//医生信息
      patientInfo: {},//患者信息
      recipesList: {},//处方列表
      ctOrderIds: [],
      diagnosisList: [],
      diagnosis: "",
      resultDialogShow: false,//结果查询弹框
      orderPayNumber: '',
      orderNumber: '',
      registerObj: {},//挂号费对象
      ybPayWay: '1',//医保支付方式 1 统筹 2个账
      tcRecipe: [],//可统筹处方数据
      disease: null,//慢特病
      cumObj: null,//统筹信息
      relationDialogShow: false,//选择亲属关系弹框
      gjRelation: '',//共济关系
      isGj: false,//是否共济
      gjLoading: false,//共济loading
      gjLoadingText: '',
      kinsfolkObj: {},
      is_wlt_acct: '0',//是否使用钱包
      ybPropertyList: ybPropertyList,
      relationOption: [],
      minpacuntDrugTracCnt: null,
      ybScope: null,
      beforeAnalyzeResult: [],
      beforeAnalyzeColumn: [
        { label: "规则名称", prop: "rule_name", width: 200, showOverflowTooltip: true },
        { label: "违规内容", prop: "vola_cont", showOverflowTooltip: true },
        { label: "违规金额", prop: "vola_amt", width: 80 },
        { label: "严重程度", prop: "sev_deg", width: 80, formatter: (row) => { return RULE_SEV_DEG[row.sev_deg] } },
      ],
      beforeAnalyzeShow: false
    }
  },
  computed: {
    formatNumber() {
      let self = this;
      return function (val) {
        // 对计算属性进行传参
        if (val) {
          return self.$toFixed(val);
        }
      };
    },
    computedYBPayTotal() {
      let total = 0
      let temp = this.$bigNumber(this.setlinfo.fund_pay_sumamt, '+', this.setlinfo.acct_pay)
      total = this.$bigNumber(temp, '+', this.gjSetlinfo.acct_pay || 0)
      total = this.$bigNumber(total, '+', this.setlinfo.exp_content_obj && this.setlinfo.exp_content_obj.wltpay_amt ? this.setlinfo.exp_content_obj.wltpay_amt : 0)
      return total
    },
    acctPayFun() {
      return this.$bigNumber(this.chargeInfo.realPay, '-', this.yibaoObj.price, 2)
    },
    computedBeforeAnalyzeNext(){
      let beforeAnalyzeConfList = isNull(this.$session.get('deptInfo').chsInfo.beforeAnalyzeConf) ? [] : this.$session.get('deptInfo').chsInfo.beforeAnalyzeConf.split(',')
      return this.beforeAnalyzeResult.some(v=>{ return beforeAnalyzeConfList.includes(v.sev_deg) })
    }
  },
  async created() {
    let relationOption = await CommonDTO.getYbOption({ type: 'relation' })
    this.relationOption = relationOption.filter(v => { return v.value != '0' })
    let { doctorInfo, patientInfo, recipesList, diagnosisList, diagnosis, ctOrderIds, orderId,registerObj } = this.dialogObj
    this.doctorInfo = doctorInfo
    this.patientInfo = patientInfo
    this.recipesList = recipesList
    this.ctOrderIds = ctOrderIds
    this.diagnosisList = diagnosisList
    this.registerObj = isNull(registerObj) ? {} : registerObj
    if (diagnosisList.findIndex(v => { return v.ybScope == '2' }) > -1) {
      this.isYbScope = 2
    }
    if (diagnosisList.every(v => { return v.ybScope == '1' })) {
      this.isYbScope = 1
    }
    this.diagnosis = diagnosis
    this.loading = true
    await this.calcYbTcDoseNum(orderId)
    this.queryOrder()
    initData()
    this.$initYB(this)
  },
  methods: {
    /**
     * 确定按钮
     */
    submit() {
      settlementCall(this)
    },
    /**
     * 下一步
     */
    next: debounce(function () {
      if (this.isGj) {
        this.yibaoObj.gjInsuinfoObj = this.insuinfoList.find(item => { return item.insutype == this.insutype })
        this.gjSetlinfo = {}
        gjSettlement(this)
      } else {
        this.yibaoObj.insuinfoObj = this.insuinfoList.find(item => { return item.insutype == this.insutype })
      }
      this.insuranceDialogShow = false;
    }, 1000, true),
    /**
     * 取消
     */
    cancel() {
      this.dialogVisible('yibaoDialog')
    },
    /**
   * 关闭
   */
    dialogVisible(name) {
      this.$emit("close", name);
    },
    /**
   * 医保药品选项发生改变
   */
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.yibaoObj.price = this.computedTotalPrice()
      this.yibaoObj.sum_amount = this.yibaoObj.price
    },
    /**
   * 社保结算
   */
    settlement: debounce(function () {
      try {
        if (Utils.le(this.multipleSelection.length, 0)) {
          return this.$message.error('至少选择一个扣费项目')
        }
        if (isNull(this.yibaoObj.relation)) {
          return this.$message.error('请选择刷卡人和患者关系！')
        }
      } catch (error) {
        CommonDTO.saveLogDTO({ businessType: '1', errorMsg: error.message })
      }
      settlement(this);
    }, 700, true),
    /**
     * 取消结算
     */
    async cancelSettlement() {
      this.dialogShow = false
    },
    //查询可统筹剂量
    calcYbTcDoseNum(orderId) {
      if(isNull(orderId)) return
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let { code, data } = await orderDTO.calcYbTcDoseNum({ orderId })
        if (code == 200) {
          if (!isEmptyArray(data)) {
            this.recipesList.forEach(item => {
              data.forEach(obj => {
                // 非理疗项目
                if (item.recipeType !='3' && item.recipeId == obj.recipeId) {
                  item.tcDoseNum = obj.tcDoseNum
                }
                // 理疗项目
                if(item.recipeType =='3' && item.recipeId == obj.recipeId){
                  item.items && item.items.forEach(v => {
                    v.items && v.items.forEach(i => {
                      if(i.artNo == obj.artNo){
                        i.ybTcDoseNum = obj.tcDoseNum
                      }
                    })
                  })
                }
              })
            })
          }
          console.log(this.recipesList,44444444444);
          
          this.tcRecipe = data || []
        } else {
          this.tcRecipe = [];
        }
        resolve()
      })
    },
    //切换医保支付方式
    ybPayWayChange() {
      this.yibaoObj.items = handleItems(this);
      this.$nextTick(() => {
        this.yibaoObj.items.forEach(item => {
          this.$refs.multipleTable.$refs.customTable.toggleRowSelection(item);
        })
      })
    },
    //共济支付
    gjPay: debounce(function () {
      personInfo(this)
    }, 500, true),
    //共济取消
    gjDialogClose() {
      this.isGj = false
      this.cancel()
      this.$emit('gjCancel')
    },
    //选择共济关系
    relationSelect() {
      if (isNull(this.gjRelation)) {
        this.$message.warning('请选择亲属关系')
        return
      }
      this.relationDialogShow = false;
      this.gjDialogShow = false
      this.isGj = true
      this.insuranceDialogShow = true
    },
    async queryOrder() {
      if (isNull(this.ctOrderIds) || isEmptyArray(this.ctOrderIds)) return;
      let { code, data } = await queryOrder({ orderIds: this.ctOrderIds })
      if (code == 200) {
        let total = 0
        data && data.forEach(v1 => {
        this.recipesList && this.recipesList.forEach(v2 => {
            if (v1.orderNumber == v2.paymentOrderNum) {
              v2.items && v2.items.forEach(v3 => {
                v3.items && v3.items.forEach(i1 => {
                  v1.details && v1.details.forEach(i2 => {
                    if (i1.artNo == i2.productNumber) {
                      total = this.$bigNumber(total, '+', isNull(i2.minpacuntDrugTracCnt) ? 0 : i2.minpacuntDrugTracCnt)
                      i1.min_pac_cnt = i2.minpacuntDrugTracCnt
                      i1.min_pacunt = i2.unit || null
                    }
                  })
                })
              })
            }
          })
        })
        this.minpacuntDrugTracCnt = total
      }
    },
    computedTotalPrice() {
      let total = 0
      this.multipleSelection.forEach(v => {
        total = this.$bigNumber(total, '+', v.det_item_fee_sumamt, 2)
      })
      return total
    },
    beforeAnalyzeClose() {
      this.beforeAnalyzeShow = false
      this.loading = false
      let warns = []
      this.beforeAnalyzeResult.forEach(v => {
        warns.push({
          warn_rslt_id:v.jr_id,
          dspo_way:'2',
          dspo_way_rea:''
        })
      })
      feedback(warns,this)
    },
    async beforeAnalyzeConfirm() {
      this.beforeAnalyzeShow = false
      this.loading = true
      let warns = []
      this.beforeAnalyzeResult.forEach(v => {
        warns.push({
          warn_rslt_id:v.jr_id,
          dspo_way:'1',
          dspo_way_rea:''
        })
      })
      let flag = await feedback(warns,this)
      if(flag){
        preSettlement(this.request_2204Obj.request_2204[0].mdtrt_id, this)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.yb-warp {
  .overflow-ellipsis {
    max-width: 184px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .yibaoDialogRef {
    position: relative;

    .yibaoDialogRef-input {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
    }
  }

  .yibaoTable {
    margin-top: 20px;
    max-height: 300px;
    overflow: auto;
  }

  .dialog-footer {
    margin-top: 20px;
    text-align: right;
  }

  .success-warp {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 64px;

    .success-title {
      text-align: center;
      font-size: 24px;
      font-weight: bold;
      color: #1F2329;
    }

    .info-warp {
      width: 343px;
      box-sizing: border-box;
      background-color: #F9F9FA;
      padding: 18px 24px;
      border-radius: 2px;
      border: 1px solid #EBEAEE;
      margin-top: 24px;
    }

    .close-btn {
      margin-top: 24px;
    }
  }

}

.chrage-detail {
  width: 100%;
}

.detail-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: #1F2329;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
}

.detail-btn {
  margin-top: 20px;
  display: flex;
  justify-content: end;
}

.col-5A6678 {
  color: #5A6678;
  font-weight: 400;
}

.insutype-warp {
  /deep/.el-radio {
    display: flex;
    margin-bottom: 20px;
    font-size: 14px;

    .el-radio__input {
      flex-shrink: 0;
      flex-grow: 0;
    }

    .balc {
      color: #abaaaa;
      margin-top: 8px;
    }
  }

  .btn {
    text-align: right;
  }
}

.gj-warp {
  .gj-title {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #1F2329;
  }

  .gj-text {
    margin-top: 20px;
    line-height: 20px;
    color: #1F2329;
  }

  .btn {
    text-align: center;
    margin-top: 30px;
  }
}

.result-warp {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  color: #1F2329;

  .result-title {
    font-size: 18px;
    font-weight: bold;
  }

  .tips {
    margin-top: 10px;
    line-height: 20px;
    font-size: 14px;
  }
}
</style>
